export const DROPDOWN_MENU = '.dropdown-menu';
export const DROPDOWN_TOGGLE = 'dropdown-toggle';
export const VISIBLE = 'visible';
